import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { Form } from 'react-redux-form';
import Textfield from '../ui/text-field';
import Headline from '../ui/headline';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: ''
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handleSubmit = event => {
        const userName = event.username;
        const password = event.password;
        if (userName === null || password === null) {
            alert('Username and Password is required');
        } else {
            this.props.devLogin(userName, password, this.props.history);
        }
    };

    render() {
        if (this.props.authentication) {
            return <Redirect to="/" />;
        }

        return (
            <Form
                className="dev-login"
                model="devLogin"
                onSubmit={this.handleSubmit}
            >
                <Headline tagValue="1" title="Login Development" />

                <Textfield
                    model="devLogin.username"
                    title="User Name"
                    defaultValue={this.state.username}
                    onChange={this.handleChange}
                />
                <Textfield
                    model="devLogin.password"
                    title="Password"
                    defaultValue={this.state.password}
                    onChange={this.handleChange}
                    type="password"
                />

                {this.props.errorMessage && (
                    <div className="errorMessage">
                        Error: {this.props.errorMessage}
                    </div>
                )}

                <button className="btn btn--primary" type="submit">
                    Login
                </button>
            </Form>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/index.js